export default {
    shared: {
        noMatch: 'No pages match.',
        menusLink: 'Menus',
        viewOnSite: 'View on site',
        openInNewTab: 'Open {url} in a new tab',
        notLiveYet: 'Not published: {url} is not live yet',
    },
    list: {
        title: 'Pages',
        search: 'Search title or slug',
        newPage: 'New page',
        createOne: 'Create one',
        menusNote: 'Which menus a page appears in, its link text, order, and nesting are managed on the {menus} screen.',
    },
    row: {
        draft: '{locale}: draft',
        defaultLanguage: '{locale}: default language',
        defaultLanguageDraft: '{locale}: default language (draft)',
        translated: '{locale}: translated',
        translatedDraft: '{locale}: translated, not published yet',
        notTranslated: '{locale}: not translated (shows {fallback})',
    },
    picker: {
        label: 'Page',
        placeholder: 'Search pages…',
        loadFailed: 'Failed to load pages',
        home: '(home) {title}',
        untitled: '(untitled)',
        draft: '(draft)',
    },
    edit: {
        newTitle: 'New page',
        editInline: 'Edit inline',
        created: 'Page created',
        confirmDelete: 'Delete "{title}"? This deletes every language of it and cannot be undone.',
        tabEdit: 'Edit {locale}',
        tabAdd: "Add {locale}: fields you don't translate keep showing {fallback}",
        tabDefault: 'default',
        tabDraft: 'draft',
        translateEmpty: 'Translate empty',
        translateEmptyTitle: 'Fill the empty boxes below with a {locale} translation of {fallback}. Nothing is saved until you press Save.',
        nothingToTranslate: 'Title, URL and description already have {locale} text',
        nothingLeft: 'Nothing left to translate',
        unaddable: "This page is stored in {pageLocale}, so {locale} (the site's default language) can't be added to it: the default language is always the page itself.",
        translationAdded: '{locale} added; untranslated fields keep showing the default language',
        translationRemoved: '{locale} removed',
        confirmRemoveTranslation: 'Remove the {locale} version? Visitors there will see {fallback} again.',
        editingBanner: 'Editing {locale}. Anything left blank falls back to {fallback}, including page content, which is translated on the {link}.',
        inlineEditorLink: 'inline editor',
        slug: 'URL slug',
        slugHintHome: 'Empty = home page',
        slugHintTranslation: "This language's own URL segment",
        settings: 'Settings',
        locale: 'Locale',
        template: 'Template',
        templateShared: '{name} (shared)',
        templateSharedNote: 'Template {template} is shared by every language: change it on the {locale} tab.',
        navigationNote: 'Navigation (which menus this page appears in, its link text, order, and nesting under a parent) is managed on the {menus} screen.',
        publishLocale: 'Publish {locale}',
        publishOnSave: 'Publish on save',
        untilPublished: 'Until this is published, visitors in {locale} see {fallback}.',
        access: 'Access',
        thisLanguage: 'This language',
        removeLocale: 'Remove {locale}',
        removeLocaleHint: "Removes this language's text only. The page stays, and {locale} visitors see {fallback} again.",
        saveLocale: 'Save {locale}',
    },
    translate: {
        translated: 'Translated {n} field: review and save | Translated {n} fields: review and save',
        failed: 'Could not translate {n} field | Could not translate {n} fields',
        partial: 'Translated {filled} of {total} fields; {failed} needs doing by hand | Translated {filled} of {total} fields; {failed} need doing by hand',
    },
};
